import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function ReportAnalysis({ reporte, tr }) {
    return (
        <Box
            data-pdf-unframe
            sx={{
                mt: 3,
                p: 3,
                border: '1px solid #C4CFDE',
                borderRadius: 2,
            }}
        >
            <Typography sx={{
                fontSize: '18px',
                fontWeight: 600,
                letterSpacing: '-0.308px',
                lineHeight: '23.4px',
                color: 'text.primary',
                mb: 1.5,
            }}>
                {tr('desc_analysis')}
            </Typography>
            <Typography
                data-pdf-normalize-text
                sx={{
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '-0.07px',
                    lineHeight: '25.6px',
                    color: 'text.primary',
                    whiteSpace: 'pre-line',
                }}
            >
                {reporte}
            </Typography>
        </Box>
    );
}
